import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Building2, Loader2, Send, Package } from "lucide-react";
import { api, apiError } from "../lib/api";
import { rupiah } from "../lib/format";
import { useAuth } from "../context/AuthContext";

const STAGE_ORDER = ["PLACED", "PURCHASED", "GUANGZHOU_HUB", "CUSTOMS", "INDO_WAREHOUSE", "DISPATCHED_KEDAI", "READY_PICKUP", "COMPLETED"];

export default function IndukKedai() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [kiosks, setKiosks] = useState([]);
  const [busy, setBusy] = useState({});

  const load = () => {
    api.get("/orders").then((r) => setOrders(r.data.orders));
    api.get("/kiosks", { params: { all: true } }).then((r) => setKiosks(r.data.kiosks));
  };
  useEffect(load, []);

  const arrived = orders.filter((o) => ["INDO_WAREHOUSE", "CUSTOMS"].includes(o.status));
  const forwarded = orders.filter((o) => STAGE_ORDER.indexOf(o.status) >= STAGE_ORDER.indexOf("DISPATCHED_KEDAI"));
  const kioskName = (id) => kiosks.find((k) => k.id === id)?.name || "—";

  const forward = async (id) => {
    setBusy((b) => ({ ...b, [id]: true }));
    try { await api.patch(`/orders/${id}/status`, { status: "DISPATCHED_KEDAI" }); toast.success("Barang diteruskan ke kedai"); load(); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy((b) => ({ ...b, [id]: false })); }
  };

  return (
    <div className="max-w-5xl mx-auto px-6 py-8">
      <div className="flex items-center gap-3 mb-2"><Building2 className="text-emerald-700" size={26} /><h1 className="font-display text-2xl font-bold text-stone-900">Panel Induk Kedai</h1></div>
      <p className="text-stone-500 mb-6 text-sm">Gudang besar daerah {user?.region ? `(${user.region})` : ""}. Terima barang dari Jakarta lalu teruskan ke kedai kecil terdekat.</p>
      <div className="grid sm:grid-cols-2 gap-4 mb-8">
        <div className="bg-white rounded-2xl border border-stone-200 p-5"><Package className="text-emerald-600 mb-2" size={22} /><p className="text-2xl font-display font-bold">{arrived.length}</p><p className="text-sm text-stone-500">Barang siap diteruskan</p></div>
        <div className="bg-white rounded-2xl border border-stone-200 p-5"><Send className="text-sky-600 mb-2" size={22} /><p className="text-2xl font-display font-bold">{forwarded.length}</p><p className="text-sm text-stone-500">Sudah diteruskan ke kedai</p></div>
      </div>
      <h2 className="font-display font-semibold text-lg mb-3">Barang Masuk Gudang</h2>
      <div className="space-y-3">
        {arrived.length === 0 && <p className="text-stone-400 text-sm" data-testid="induk-empty">Belum ada barang yang masuk gudang.</p>}
        {arrived.map((o) => (
          <div key={o.id} data-testid={`induk-order-${o.id}`} className="bg-white rounded-2xl border border-stone-200 p-4 flex flex-wrap items-center gap-3">
            <div className="flex-1 min-w-[200px]">
              <p className="font-mono text-xs text-stone-400">{o.awb}</p>
              <p className="text-sm font-medium text-stone-800">{o.user_name} · {rupiah(o.total_idr)}</p>
              <p className="text-xs text-stone-400">Tujuan kedai: {kioskName(o.kiosk_id)} · status: {o.status}</p>
            </div>
            <button data-testid={`induk-forward-${o.id}`} onClick={() => forward(o.id)} disabled={busy[o.id]} className="bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold px-4 py-2 rounded-lg flex items-center gap-1.5 disabled:opacity-60">{busy[o.id] ? <Loader2 className="animate-spin" size={15} /> : <Send size={15} />}Teruskan ke Kedai</button>
          </div>
        ))}
      </div>
    </div>
  );
}
